import React, { useEffect, useState } from 'react';
import '../ChatDetail/ChatDetail.css';
import ChatInputRedirect from '../../Component/ChatInputRedirect/ChatInputRedirect';
import MessageUser from '../ChatDetail/Item/MessageUser';

export default function AboutUs() {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const ac = new AbortController();
        async function load() {
            try {
                setLoading(true);
                const res = await fetch(`${process.env.REACT_APP_API_SERVER_URL}/about`, { signal: ac.signal });
                if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);

                let data;
                try {
                    data = await res.json();
                } catch (e) {
                    data = await res.text();
                }

                let c = '';
                if (data && typeof data === 'object') {
                    c = data.content ?? JSON.stringify(data);
                } else {
                    c = data ?? '';
                }

                setContent(c);
            } catch (e) {
                if (e.name === 'AbortError') return;
                setError(e.message || 'Lỗi khi tải nội dung');
            } finally {
                setLoading(false);
            }
        }
        load();
        return () => ac.abort();
    }, []);

    return (
        <div className="chat-detail-container">

            <div className="chat-detail-messages aboutus-content">
                <MessageUser message={"Giới thiệu Pippip"} />

                {loading && <div className="aboutus-loading">Đang tải...</div>}
                {error && <div className="aboutus-error">{error}</div>}

                {!loading && !error && (
                    // If content looks like HTML, render as HTML. Otherwise render as text.
                    (typeof content === 'string' && /<\/?[a-z][\s\S]*>/i.test(content)) ? (
                        <div className="aboutus-html" dangerouslySetInnerHTML={{ __html: content }} />
                    ) : (
                        <div className="aboutus-text">{content}</div>
                    )
                )}
            </div>

            <div className="chat-detail-input-row">
                <div className="chat-input-redirect">
                    <ChatInputRedirect />
                </div>
            </div>
        </div>
    );
}
